import { QueryHookOptions, useQuery } from '@apollo/client';
import getManagedDepotsQuery from './managedDepotsFromPlatformAccount.graphql';

export const useManagedDepotsFromPlatformAccountQuery = (
  options: QueryHookOptions<ManagedDepotsQuery, ManagedDepotsQueryVariables>,
) => {
  return useQuery<ManagedDepotsQuery, ManagedDepotsQueryVariables>(
    getManagedDepotsQuery,
    options,
  );
};
